import { Modal, inputCls, btnPrimary } from "../bits";

export function CircularEditModal({ editModal, setEditModal, editFileRef, busy, onSave }) {
  return (
    <Modal open={!!editModal} onClose={() => setEditModal(null)} title="تعديل التعميم" testid="circular-edit-modal">
      {editModal && (
        <div className="space-y-3">
          <div>
            <label className="text-xs font-bold text-mutext block mb-1.5">عنوان التعميم *</label>
            <input data-testid="circular-edit-title" value={editModal.title} onChange={(e) => setEditModal({ ...editModal, title: e.target.value })} className={inputCls} />
          </div>
          <div>
            <label className="text-xs font-bold text-mutext block mb-1.5">تاريخ الإصدار (هجري) *</label>
            <input data-testid="circular-edit-date" value={editModal.issue_date} onChange={(e) => setEditModal({ ...editModal, issue_date: e.target.value })} className={inputCls} dir="ltr" />
          </div>
          <div>
            <label className="text-xs font-bold text-mutext block mb-1.5">استبدال الملف (اختياري)</label>
            <input ref={editFileRef} data-testid="circular-edit-file" type="file" accept=".pdf,image/jpeg,image/png" className={inputCls} />
          </div>
          <button data-testid="circular-edit-save" onClick={onSave} disabled={busy} className={`${btnPrimary} w-full justify-center`}>
            {busy ? "جارٍ الحفظ …" : "حفظ التعديلات"}
          </button>
        </div>
      )}
    </Modal>
  );
}
